import React, { useCallback } from 'react'
import useChartTraces from 'src/Hooks/use-chart-traces'
import { TraceKey } from 'src/Libs/system-charts/shared/config/traceConf'
import { useTypedSelector } from 'src/State/RootReducer'
import { getFilteredAvailableTraceKeysForCustomChart } from '../../shared/utils/available-lines-fns'
import { ChartType, CustomTrace } from '../../shared/utils/chartModel'
import LegendItem from '../../shared/components/LegendItem'
import { useWallboxHardwareByStorage } from 'src/Libs/wallboxes/hooks'

export interface AvailableTracesProps {
  chartType: ChartType
  availableLines: TraceKey[]
  currentTraces: CustomTrace[]
  setCurrentTraces: React.Dispatch<React.SetStateAction<CustomTrace[]>>
}

const AvailableTraces: React.FC<AvailableTracesProps> = ({ chartType, availableLines, currentTraces, setCurrentTraces }) => {
  const { getTraceInfoFromName } = useChartTraces()
  const { data: wallboxes } = useWallboxHardwareByStorage()
  const powermeters = useTypedSelector(store => store.storage.powermeterHardware)

  const filteredAvailableTraceKeys = getFilteredAvailableTraceKeysForCustomChart(availableLines, wallboxes, powermeters)

  const traceIsNotAlreadyUsed = useCallback(
    (traceKey: string) => {
      const traceIsUsed = currentTraces.map(trace => trace.alternateKey ?? trace.key).includes(traceKey)
      return !traceIsUsed
    },
    [currentTraces]
  )

  return (
    <>
      {filteredAvailableTraceKeys
        .filter(traceKey => traceIsNotAlreadyUsed(traceKey))
        .map((trace, index) => {
          const { configuration, key, name, alternateKey } = getTraceInfoFromName(trace)
          const chartTypeIconType = chartType === 'bar' ? 'bar' : 'line'
          const legendIconType = key === 'ASOC' ? 'gradient' : chartTypeIconType

          return (
            <LegendItem
              key={`${index}-${trace}`}
              type={legendIconType}
              color={configuration.custom?.color ?? 'blue'}
              title={name}
              onClick={() =>
                setCurrentTraces(traces => [
                  ...traces,
                  {
                    ...configuration.custom,
                    key,
                    alternateKey,
                    name,
                  },
                ])
              }
            />
          )
        })}
    </>
  )
}

export default AvailableTraces
